// Local Url
export const apiURL = "https://tkmsports-api.orientaloutsourcing.in/api/";
